import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 2H1V18H13V16C13 15.3015 13.1102 14.6287 13.3141 13.998H3V3.99805H21V9.67393C21.7204 9.8441 22.3945 10.1341 23 10.5218V2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3 20H13V22H3V20Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.2515 14.75C18.2515 14.0596 18.8111 13.5 19.5015 13.5C19.8456 13.5 20.1555 13.6377 20.3826 13.8634L21.0919 14.5683L22.5017 13.1498L21.7925 12.4448C21.206 11.8619 20.395 11.5 19.5015 11.5C17.7065 11.5 16.2515 12.9551 16.2515 14.75V15.5H15V22H24V15.5H18.2515V14.75Z"}}]};

const SystemUnlockedFilled = Vue.extend<IconProps>({
  name: 'SystemUnlockedFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'system-unlocked-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default SystemUnlockedFilled;
